export default __webpack_public_path__ + "static/media/pineJt1.62406c83.png";